import { hMacAjax } from 'grt-tool-lib-front';
import { baseURL } from '@/httpService/API';
// const baseUserURL = `${baseURL}/grt-user-service`;
const mallUserServiceURL = `${baseURL}/grt-trade-service/user`;
let url = {
    list: '/invoice/v1/page/search',
    create: '/invoice/applicationInvoice',
    detail: '/invoice/v1/detail/'
};
//发票列表
export const getReceiptList = (data) => {
    return hMacAjax.post(mallUserServiceURL + url.list, data);
};
//创建发票
export const createReceipt = (data) => {
    return hMacAjax.post(mallUserServiceURL + url.create, data);
};

//退款详情
export const getReceiptDetail = (id) => {
    return hMacAjax.get(mallUserServiceURL + url.detail + id);
};
